if (!$.fn.resetSS) $.fn.resetSS = function () { return this; };

var helpBubblesOnly = false;

$.fn.extend({
    popoverClosable: function (options) {
        var defaults = {
            html: true,
            template:
                '<div class="popover">\
<div class="arrow"></div>\
<div class="popover-header">\
<button type="button" class="closePopover" data-dismiss="popover" aria-hidden="true">&times;</button>\
<h3 class="popover-title"></h3>\
</div>\
<div class="popover-content"></div>\
</div>'
        };
        options = $.extend({}, defaults, options);
        var $popover_togglers = this;
        $popover_togglers.popover(options);
        $popover_togglers.on('click', function (e) {
            e.preventDefault();
            $popover_togglers.not(this).popover('hide');
        });
        $('html').on('click', '[data-dismiss="popover"]', function (e) {
            $popover_togglers.popover('hide');
        });

        //hook up all help popovers to close when click outside them
        $('body').on('click', function (e) {
            $($popover_togglers).each(function () {
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });
    }
});

$.fn.memberAutoLoad = function (onLoadComplete, onLoadFail) {
    return this.each(function () {
        var $this = $(this);
        var oldxhr = $this.data('xhr');
        var url = $this.attr('data-url');
        var param = $this.attr('data-param-id');
        if (param) url += (/\?/.test(url) ? '&' : '?') + 'id=' + encodeURIComponent(param);
        param = $this.attr('data-param-index');
        if (param) url += (/\?/.test(url) ? '&' : '?') + 'index=' + encodeURIComponent(param);
        url += (/\?/.test(url) ? '&' : '?') + 'random=' + Math.floor(Math.random() * 1000);
        $this.first().show().nextAll(':not(.keep)').remove();
        if (oldxhr) oldxhr.abort();
        var xhr = $.ajax(url)
            .done(function (r, s, xhr) {
                var redirecturl = xhr.getResponseHeader('PEPRedirectURL');
                if (redirecturl) {
                    if (typeof (onLoadFail) == 'function') {
                        onLoadFail();
                    }

                    window.location.href = redirecturl;
                    
                    return;
                }
                $this.hide().nextAll().remove();
                $this.after(r);
                var func = $this.attr("data-onload");
                if (func && window[func]) {
                    window[func]();
                }
                if (typeof (onLoadComplete) == 'function') {
                    onLoadComplete();
                }
                // Ensure the sticky left-nav is positioned correctly after the page expands from loading async content
                if ($('#sideMenuList').length > 0 && $('#sideMenuList').affix !== undefined)
                    $('#sideMenuList').affix('checkPosition');
            })
            .fail(function (xhr, s, e) {
                window.rquid = xhr.getResponseHeader("rquid");
                window.errcat = xhr.getResponseHeader("errcat");
                window.uname = xhr.getResponseHeader("uname");

                if (typeof (onLoadFail) == 'function') {
                    onLoadFail();
                }
                
                if (s == 'abort' || xhr.status == 0) {
                    return;
                }

                if (window.pep && window.pep.debug) {
                    $this.hide();
                    var text = 'Unknown Error';
                    if (s == 'error') text = xhr.responseText || 'Oops, the server is having problems.';
                    else if (s == 'abort') text = '';
                    else if (s == 'timeout') text = "Oops. The server does not appear to be responding.";
                    if ($this.is('tr')) $this.after($('<tr></tr>').append($('<td class="loadErrorDiv"></td>').append(text)));
                    else $this.after($('<div class="loadErrorDiv"></div>').append(text));
                }
                else {
                    redirectToErrorPage();
                    return;
                }
            })
            .always(function () {
                $this.removeData('xhr');
            });
        $this.data('xhr', xhr);
    });
};

$(function () {
    $.ajaxSetup({
        error: function (xhr, s) {
            window.rquid = xhr.getResponseHeader("rquid");
            window.errcat = xhr.getResponseHeader("errcat");
            window.uname = xhr.getResponseHeader("uname");

            if (s === "timeout" && xhr.status == 0) {
                redirectToErrorPage();
            }

            if (s == 'abort' || xhr.status == 0) {
                return;
            }

            if (window.pep && window.pep.debug)
                alert(xhr.responseText);
            else
                redirectToErrorPage();
        },
        timeout: (window.pep && window.pep.debug) ? (30 * 60 * 1000) : 65000,
        headers: { "cache-control": "no-cache" }
    });

    //put stuff in here if it should be re-called whenever new content runs
    initializeMemberPage(window.memberAutoLoadRun);

    //put one time load stuff here
    $('body').append('<div id="helpPanel" style="display:none;"></div>');
    $pepHelp = $('#helpPanel').pepHelp();
})

function initializeMemberPage(bypassMemberAutoLoad)
{
    setupSelectLists();

    if (!bypassMemberAutoLoad) {
        $(".memberAutoLoad").memberAutoLoad();
        window.memberAutoLoadRun = true;
    }
    $(window).on('unload', function () {
        $(".memberAutoLoad").each(function () {
            var xhr = $(this).data('xhr');
            if (xhr) xhr.abort();
            $(this).removeData('xhr', null);
        });
    });

    $("form").each(function () {
        var val = $.data(this, 'validator');
        if (val) {
            val.settings.ignore = "input[type=range],:hidden:not([type=hidden]):not(.alwaysValidate)";
        }
    });
    $('[data-toggle="popover"]').popoverClosable();
    removeInputTypes();
};

function setupSelectLists($container) {    
    var $container = (typeof ($container) === "undefined" ? $('body') : $container);
    $container.find('select').not(".suppressNotPicked").each(function () {
        var $sel = $(this);

        var setSelectWatermarkStyle = function () {
            var $this = $(this);
            if ($this.val() === "") {
                $this.addClass('notPicked');
            } else $this.removeClass('notPicked');
            //Nexus 4 hack -This hack was added to address Defect # 14323 - Removed this Hack because it puts the focus on the incorrect select control. Defect # 25397
            //$this[0].blur();
            //$this[0].focus();
        };

        $sel.on('change', setSelectWatermarkStyle);

        var prettyName = $sel.attr("data-default-text") || "Select one...";


        var $opt = $sel.find("option:first");
        if ($opt.val() === "" && (!isMobile.any() && !isSafari() && !isEdge())) {
            $opt
                .attr("disabled", "disabled")
                .text(prettyName);
        }
        else if ($opt.val() === "") {
            $opt
                .text(prettyName);
        }

        setSelectWatermarkStyle.call($sel);
    });
}

var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

mobileApp = (function (mobileApp) {
    var $ready = new $.Deferred();
    document.addEventListener('deviceready', function () { $ready.resolve(); }, false);
    mobileApp.ready = function (f) { $ready.done(f); };
    return mobileApp;
})(window.mobileApp || {});

function isSafariDevice() {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

function isSafari() {
    return (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0);
}

function isEdge() {
    return navigator.userAgent.indexOf('Edge') !== -1;
}

function paymentDialogClosedForceRefresh() {
    paymentDialogClosed(true);
}

function paymentDialogClosed(success) {
    if (success) {
        pep.waitMessage.show();
        window.setTimeout(function () { document.location = document.location; });
    }
}

function redirectToErrorPage() {
    var url = "/oops";

    var qs = [];
    if (window.rquid) qs.push("rquid=" + window.rquid);
    if (window.errcat) qs.push("errcat=" + window.errcat);
    if (window.uname) qs.push("uname=" + window.uname);

    if (qs.length)
        url += "?" + qs.join("&");

    window.top.location.href = url;
}

function openStandardDialog(relativeUrl, width, height) {
    var $dialog = pepDialog.open(pep.site.root + relativeUrl, {
        title: "Loading...",
        height: height || 470,
        width: width || 580,
        fullSizeIFrame: true,
        draggable: false,
        onLoadComplete: pepWizard.onLoadComplete
    });

    return $dialog
}

function siteCatalystTagging(docType, polType) {
    parent.s.pageName = "pemco:members:documents:ViewPDF:" + docType + (polType != null && docType != "AutoIdCard" ? ":" + polType : "");

    if (ecommSiteCatalystUtility)
        ecommSiteCatalystUtility.sendBeacon(parent.s);

    parent.s.events = "";
    parent.s.pageName = "";
    s.pageName = "";
}

function viewportHelper() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

//set all the type variables to text for all browsers that are not mobile.
function removeInputTypes(form) {
    if (!isMobile.any()) {
        var container = $('body');
        if (typeof form != 'undefined') {
             container = form;
        }
        container.find('input[type="tel"],input[type="number"]').each(function () {
            this.type = 'text';
        });
    }
}

function showSimpleModal(title, body, opts) {
    var deferred = $.Deferred();

    var options = $.extend(
        {
            button1: "Cancel",
            button2: "Ok",
            width: "",
            height: "",
            reload: false,
            canDismiss: false,
            isAsync: false,
            postUrl: undefined,
            onError: undefined,
            onSubmit: undefined,
            onSubmitted: undefined,
            onCancel: undefined,
            onClose: undefined
        },
        opts);

    if (options.reload) $('#bsModal').remove();

    var htmlButton1 = "";
    var htmlButton2 = "";
    var xButton = "";

    if (options.button1.length > 0)
        htmlButton1 = '<button type="button" id="button1" class="btn btn-default btn-secondary" data-dismiss="modal" data-deferred-action="reject" data-deferred-val="cancel"><span>' + options.button1 + '</span></button>';

    if (options.button2.length > 0)
        htmlButton2 = '<button type="button" id="button2" class="btn btn-primary pull-right" data-deferred-action="resolve" data-deferred-val="continue"><span>' + options.button2 + '</span></button>';

    if (options.canDismiss)
        xButton = '<button type="button" class="close" data-dismiss="modal" data-deferred-action="reject" data-deferred-val="cancel">&times;</button>';

    var $m = $('#bsModal');

    var htmlHeader = window.mobileApp && mobileApp.isRunning ? "" : '<div class="modal-header">' +
                        xButton +
                        '<h4 class="modal-title">' + title + '</h4>' +
                      '</div>';
    
    var html = '<div id="bsModal" class="modal fade" tabindex="-1">' +
                  '<div class="modal-dialog">' +
                   '<div class="modal-content">' +
                        htmlHeader +
                      '<div class="modal-body">' + (options.isAsync ? '<img src="/_images/members/green-progress-ring.gif" alt="Progress Ring"/><span style="padding-left:20px;">Loading...</span>' : body) + '</div>' +
                      '<div class="modal-footer">' +
                        htmlButton1 +
                        htmlButton2 +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>';

    

    if ($m.length == 0) $m = $(html).appendTo('body');
    
        
    $("BODY").css("overflow", "hidden");
		//.css('position', 'fixed');  //TODO:  Talk to eric about why this fixed position is needed

    var scrollPos = 0;

    $('.modal')
        .on('show.bs.modal', function () {
            scrollPos = $('body').scrollTop();
            $('body').css({
                overflow: 'hidden',
                position: 'fixed'
            });
        })
        .on('hide.bs.modal', function () {
            $('body').css({
                overflow: '',
                position: '',
                top: ''
            }).scrollTop(scrollPos);
        });

    if (options.height.match(/\d+\%/)) {
        var resizeFunc = function () {
            var availableHeight = ($(window).height() - (($(".modal-header").outerHeight()||0) + ($(".modal-footer").outerHeight()||0)));
            var heightRatio = $("#bsModal .modal-dialog").outerWidth() == $(window).width() ? 1.0 : (options.height.replace(/\%/, "") / 100.0); // Use full height when the width is same as windows width

        var maxHeight = availableHeight * ($(window).width() < 480 ? 1.0 : heightRatio);

            $('#bsModal .modal-body')
                .css({
                    'overflow-y': 'auto',
                    'max-height': maxHeight
                });
        }

        $m.on('show.bs.modal', resizeFunc);
        $(window).resize(resizeFunc);
    }

    if (options.isAsync) {
        $('#bsModal .modal-footer .btn').hide();

        body.done(function (data) {
            $('.modal-body').html(data);

            if (mobileApp.isRunning) {
                $('#button1').show(); // show them in 2 steps to fix a defect with android mobile

                setTimeout(function () {
                    $('#button2').show();
                }, 40);
            }
            else {
                $('#bsModal .modal-footer .btn').show();
            }
            $('#bsModal .modal-footer .btn').css('display', 'inline');
        });
    }

    $m.on("hidden.bs.modal", function () {
        if (deferred.state() == "pending") deferred.reject("cancel");
        $("BODY").css("overflow-y", "auto")
			.css("position", "static");
        if (options.onClose) options.onClose();
    }).find(".btn[data-deferred-action]")
        .off("click")
        .on("click", function () {
            var $this = $(this);
            deferred[$this.attr('data-deferred-action')]($this.attr("data-deferred-val"));
            
            if ((options.postUrl != undefined || $.isFunction(options.onSubmit)) && $this.attr("data-deferred-val") == 'continue') {

                $this.prop('disabled', true);

                if ($m.find('form').valid()) {

                    if ($.isFunction(options.onSubmit)) {
                        options.onSubmit();
                    }
                    else {
                        $.ajax({
                            type: "POST",
                            url: options.postUrl,
                            data: $m.find('form').serialize(),
                            success: function (data) {
                                if (data.Errors.length > 0) {
                                    //reload the view when there is an error
                                    $('.modal-body').html(data.Data.View);
                                }
                                else {
                                    $m.modal("hide");
                                    setTimeout(function () {
                                        $('.modal-backdrop').remove();  //hack to remove the masking div in this scenario of opening up multiple dialogs in a chain
                                        if ($.isFunction(options.onSubmitted)) {
                                            options.onSubmitted();
                                        }
                                    }, 200)
                                }
                                $this.prop('disabled', false);
                            }
                        });
                    }
                }
                else {
                    $this.prop('disabled', false);
                }
            }
            else {
                $m.modal("hide");
                if ($.isFunction(options.onCancel)) {
                    options.onCancel();
                }
            }
        });

    $m.modal(
        { keyboard: options.canDismiss, backdrop: options.canDismiss ? true : 'static' } // Prevent background click from dismissing modal
    );

    return deferred.promise()
}